/* app/ui/nav/load */

define(
	'app/ui/map/map.interactive',[
		'jquery'
	],
	function ($) {

		var MapInteractive;
		var locationCache;//store all the location data
		var $map;
		var $mapContainer;
		var googleMap;
		var allMarkers = [];
		var markerBounds;
		var markerSpiderfier;
		var region;
		var $mapInteractive;
		var $mapInteractiveContainer;
		var markerClusters = [];


		// Spiderfier Config
		var spiderConfig = {
			keepSpiderfied: true,
			event: 'mouseover',
			circleSpiralSwitchover: 'Infinity'
		};

		// Cluster Config
		var clusterConfig = {
			maxZoom: 16
		};

		return {
			init: function($elm) {
				MapInteractive = this;
				$map = $elm;
				if ($map.length === 0) {
					return;
				}
				$mapContainer = $('.js-map__container');
				$mapInteractive = $('.js-figure-map-interactive');
				$mapInteractiveContainer = $('.js-interactive-map-container');
				region = $map.attr('data-region');
				MapInteractive._initSubscriptions();
			},

			_initSubscriptions: function () {
				$.subscribe('/map/apiLoaded', MapInteractive._initMap);
			},

			_initMap: function () {
				require(
					[
						'async',
						'goog',
						'googmapcluster',
						'googmapspiderfier',
						'googinfoBox'
					],
					function () {
						MapInteractive._populateMap();
					}
				);
			},

			_populateMap: function () {
				//Start of Google map call
				MapInteractive._getMapData(function (data) {

					var obj = data;
					markerBounds = new google.maps.LatLngBounds();
					var defaultZoom = 15;
					//var centerPos = new google.maps.LatLng(-39.272709, 175.580228);

					google.maps.visualRefresh = false;

					// Google Map Config
					var mapConfig = {
						mapTypeId: google.maps.MapTypeId.TERRAIN,
						//center: centerPos,
						zoom: defaultZoom,
						streetViewControl: false,
						overviewMapControl: false,
						mapTypeControl: true,
						panControl: false,
						zoomControl: true,
						zoomControlOptions: {
							style: google.maps.ZoomControlStyle.LARGE,
							position: google.maps.ControlPosition.LEFT_TOP
						},
						backgroundColor: '#a3ccff'
				};

					// Set Google Map
					googleMap = new google.maps.Map($map.get(0), mapConfig);

					// Set Spiderfier
					markerSpiderfier = new OverlappingMarkerSpiderfier(googleMap, spiderConfig);

					// Set Marker Variants Arrays
					var newMarker;

					//function infoClick(argument) {
					//	aTag = this.getElementsByTagName('a')[0];
					//	if (aTag) {
					//		location.href = aTag.href;
					//	}
					//}

					//Create Infobox
					var myOptions = {
						alignBottom: true,
						boxClass: 'infowindow js-infobox',
						closeBoxURL: '/content/images/interface/map/close.png',
						closeBoxMargin: '0',
						enableEventPropagation: true,
						infoBoxClearance: new google.maps.Size(0, 32),
						pixelOffset: new google.maps.Size(-170, -60)
						//onClick: infoClick
					};

					var ib = new InfoBox(myOptions);

					//Loop through the list
					for (var i = 0; i < obj.length; i++) {

						if (obj[i].lat && obj[i].lng && obj[i].lat !== '' && obj[i].lng !== '') {
							//Set faclilty Pins
							var mapmarker = '/content/images/interface/map/marker--black_item.png';

							var lat = parseFloat(obj[i].lat);
							var lng = parseFloat(obj[i].lng);
							//Filter the marker
							if (region === 'gisborne') {
								if (!(lat > -40 && lat < -37  && lng > 176 && lng < 179)) {
									continue;
								}
							}
							if (region === 'hawke\'s bay') {
								if (!(lat > -41 && lat < -39 && lng > 176 && lng < 177)) {
									continue;
								}
							}
							if (region === 'wairarapa') {
								if (!(lat > -41.5 && lat < -40)) {
									continue;
								}
							}
							if (region === 'marlborough') {
								if (!(lat > -42 && lat < -41 && lng < 175)) {
									continue;
								}
							}
							if (region === 'nelson') {
								if (!(lat > -42.2 && lat < -40.2 && lng > 172.2 && lng < 174.2)) {
									continue;
								}
							}
							if (region === 'canterbury') {
								if (!(lat > -45.5 && lat < -42.5 && lng > 170 && lng < 173.6)) {
									continue;
								}
							}
							if (region === 'central otago') {
								if (!(lat > -46.5 && lat < -43.5 && lng > 167 && lng < 170)) {
									continue;
								}
							}

							if (region === 'new zealand') {
								// don't filter
							}

							var myLatLng = new google.maps.LatLng(lat, lng);

							//var hardcodecontent = '<div class="c-info-window">Map Info Box</div>';
							var markerOptions = {
								position: myLatLng,
								map: googleMap,
								content: obj[i].data,
								id: obj[i].id,
								icon: mapmarker
							};

							// Populate markers array for list links
							//var subRegion = obj[i].subregion;

							newMarker = new google.maps.Marker(markerOptions);
							markerSpiderfier.addMarker(newMarker);
							allMarkers.push(newMarker);
							markerBounds.extend(myLatLng);
						}
					} // end of for loop

					googleMap.fitBounds(markerBounds);

					//Add infobox click handler
					markerSpiderfier.addListener('click', function (marker) {
						ib.setContent(marker.content);
						ib.open(googleMap, marker);
						//googleMap.panTo(ib.getPosition());
					});

					MapInteractive._cluster(googleMap, allMarkers);


				}); //End of Google map call
			},

			_getMapData: function (callback) {
				if(locationCache){
					callback(locationCache);
				}
				else {
					//var $body = $('body');
					//var lang = $body.attr('data-lang')?$body.attr('data-lang'):'en';
					//var url = '/api/getmaplocations/' + lang +'/' + region;
					var url = $map.attr('data-dataurl');
					$.get(url, function (data) {
						locationCache = data;
						callback(data);
					});
				}
			},

			_cluster: function (googleMap, markers) {
				var markerImageUrl = '/content/images/interface/map/marker--black.png';
				var clusterStyle = [{ textColor: 'white', url: markerImageUrl, height: 40, width: 25, textSize: 14, anchor: [2, 0] }];
				var myOptions = {
					gridSize: 20,
					minimumClusterSize: 2,
					styles: clusterStyle,
					maxZoom: clusterConfig.maxZoom,
					clusterIcon: markerImageUrl
				};
				//MarkerClusterer.prototype.remove = function () { }
				var markerCluster = new MarkerClusterer(googleMap, markers, myOptions);
				markerCluster.setMaxZoom(clusterConfig.maxZoom);
				markerClusters = markerCluster;
			}
		};
	}
);
